import PropTypes from 'prop-types';
import * as React from 'react';

function ResultsWrapper({ children }) {
  return (
    <div className="absolute z-50 w-full p-4 overflow-hidden text-base text-left bg-white border border-gray-100 shadow">
      {children}
    </div>
  );
}

ResultsWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ResultsWrapper };
